import React from 'react';

export const AboutCanvas: React.FC = () => {
    return (
        <div>
            About ...
        </div>
    );
};

